<section class="container-02" (sdxInView)="inView = true" [@staggerIn]="inView">
  <div class="stagger-in">
    <h5 class="lead-headline p-horizontal" [innerHTML]="cueElement.lead_text"></h5>
  </div>
</section>
